import { render, staticRenderFns } from "./ComfortTempSlider.vue?vue&type=template&id=471e5bee&scoped=true&"
import script from "./ComfortTempSlider.vue?vue&type=script&lang=ts&"
export * from "./ComfortTempSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ComfortTempSlider.vue?vue&type=style&index=0&id=471e5bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e5bee",
  null
  
)

export default component.exports